/**
 * SettingsCategoryPanel — renders the list of settings for a single category
 * as a stack of {@link SettingInput} rows, each with its own save button.
 */

import { SettingInput, type WireValueType } from '@/components/settings/SettingInput';

export interface SettingDto {
  key: string;
  value: unknown;
  valueType: WireValueType;
  category: string | null;
  description: string | null;
  isSecret: boolean;
  updatedAt: string;
}

interface Props {
  settings: SettingDto[];
  disabled?: boolean;
  savingKey: string | null;
  onSave: (key: string, value: unknown) => void;
}

export function SettingsCategoryPanel({ settings, disabled, savingKey, onSave }: Props) {
  if (settings.length === 0) {
    return (
      <p className="py-6 text-sm text-muted-foreground">Nenhuma configuração nesta categoria.</p>
    );
  }
  return (
    <div className="divide-y">
      {settings.map((s) => (
        <SettingInput
          key={s.key}
          settingKey={s.key}
          value={s.value}
          valueType={s.valueType}
          isSecret={s.isSecret}
          description={s.description}
          disabled={disabled}
          submitting={savingKey === s.key}
          onSave={(v) => onSave(s.key, v)}
        />
      ))}
    </div>
  );
}
